(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , validateNumber = require('validity-number')
  , validateIfPropertyEquals = require('@clocklimited/validity-validate-if-property-equals')
const required = require('@clocklimited/validity-required')

module.exports = function (findOne) {

  function uniqueNumberPerArtist (key, keyDisplayName, object, cb) {
    var query =
      { actName: object.actName
      , number: object.number
      }

    if (!object.actName) return cb(null, 'No Act Name set')

    findOne(query, function (err, found) {
      if (err) return cb(err)
      if (found && found._id !== object._id) {
        return cb(null, 'An invoice with number "' + found.number + '" already exists for this act')
      }
      cb()
    })
  }

  return schemata(
    { _id:
      { type: String
      }
    , number:
      { type: String
      , validators:
        { all: [ validateIfPropertyEquals('_id', undefined, validateNumber), uniqueNumberPerArtist ]
        }
      }
    , date:
      { type: Date
      , validators:
        { all: [ required ]
        }
      , defaultValue: function () { return new Date() }
      }
    , dueDate:
      { type: String
      }
    , from:
      { type: String
      }
    , fromVat:
      { type: String
      }
    , to:
      { type: String
      }
    , toVat:
      { type: String
      }
    , currency:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , tax:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , name:
      { type: String
      }
    , actName:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , showDate:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , fee:
      { type: String
      }
    , totalFee:
      { type: String
      }
    , dateCreated:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    , updateDate:
      { type: Date
      , defaultValue: function () { return new Date() }
      }
    , terms:
      { type: String
      }
    , account:
      { type: String
      }
    , show:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , status:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/invoice/schema.js","/components/service/invoice")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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